import { useNavigate } from "react-router-dom";
import React from "react";
import { PartPaymentDetail } from "us.collection.partpayments/components";

interface ICnt_PartPayments {
  caseNo: number;
  // any other props passed through to PartPaymentDetail
  [key: string]: any;
}

const Cnt_PartPayments: React.FC<ICnt_PartPayments> = (props) => {
  const navigate = useNavigate();

  const onMinimize = () => {
    navigate(`/case/${props.caseNo}`);
  };

  return <PartPaymentDetail {...props} minimize={onMinimize} />;
};

export default Cnt_PartPayments;
